export async function registerApplicantDetails(signupDetails) {
  const url = `${process.env.REACT_APP_API}/v1/api/general/register/candidate`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: signupDetails,
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: content.message };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function verifyOTP(formData) {
  const url = `${process.env.REACT_APP_API}/v1/api/general/otp-verification`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: formData,
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: content.message };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function resendOtp(formData) {
  const url = `${process.env.REACT_APP_API}/v1/api/general/resend-otp`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchScorecardData(id) {
  const token = localStorage.getItem("token");
  const endpoint = id !== undefined 
  ? `${process.env.REACT_APP_API}/v1/api/scrutiny/candidate-scorecard/${id}` 
  : `${process.env.REACT_APP_API}/v1/api/scorecard`;
  const rawResponse = await fetch(endpoint,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  
  if (rawResponse.status === 200) {
    const content = await rawResponse.json();
    return { body: content.body, success: true, message: "" };
  }
  else if (rawResponse.status === 401) {
    return { body: [], success: true, message: "" };
  }
  else {
    return { body: [], success: false, message: "Bad Request" };
  }
}

export async function declarationOtp(milestoneId) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/declaration-otp/${milestoneId}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function verifyDeclarationOtp(formData, milestoneId) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/verify-declaration-otp/${milestoneId}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchCandidateScorecardData(id) {
  const token = localStorage.getItem("token");
  const endpoint =
    id !== undefined
      ? `${process.env.REACT_APP_API}/v1/api/scrutiny/candidate-scorecard/${id}`
      : `${process.env.REACT_APP_API}/v1/api/scorecard`;
  const rawResponse = await fetch(endpoint, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (rawResponse.status === 200) {
    const content = await rawResponse.json();
    return { body: content.body, success: true, message: "" };
  } else if (rawResponse.status === 401) {
    return { body: [], success: true, message: "" };
  } else {
    return { body: [], success: false, message: "Bad Request" };
  }
}
